import React, { useMemo } from 'react';
import { loadStripe } from '@stripe/stripe-js';
import { Elements } from '@stripe/react-stripe-js';

function AsyncStripeProvider({ apiKey, children }) {
  // loadStripe must run once, not on every render, and only with a real key.
  // Calling it per-render (or with an empty key) injects js.stripe.com repeatedly
  // and can wedge hydration on stricter browsers (Safari). Elements accepts a
  // null stripe prop and still renders its children.
  const stripePromise = useMemo(() => (apiKey ? loadStripe(apiKey) : null), [apiKey]);
  return <Elements stripe={stripePromise}>{children} </Elements>;
}

export default AsyncStripeProvider;
